module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/datenschutz.json
// module id = 375
// module chunks = 206315795818788